import { Card, Flex, Typography } from "antd";
import type React from "react";
import styles from "../Dashboard.module.css";

type Props = {
  title: string;
  value: number | undefined;
  hint: React.ReactNode;
  accentColor: string;
  loading: boolean;
  onOpen: () => void;
};

export const AttentionCard = ({
  title,
  value,
  hint,
  accentColor,
  loading,
  onOpen,
}: Props) => (
  <Card
    hoverable
    loading={loading}
    className={styles.attentionCard}
    style={{ borderTopColor: accentColor }}
    role="link"
    tabIndex={0}
    onClick={onOpen}
    onKeyDown={(event) => {
      if (event.key === "Enter") onOpen();
    }}
  >
    <Flex vertical gap="small">
      <Typography.Text type="secondary">{title}</Typography.Text>
      <Typography.Text className={styles.attentionValue}>{value ?? 0}</Typography.Text>
      <Typography.Text type="secondary">{hint}</Typography.Text>
    </Flex>
  </Card>
);
